/* eslint-disable @typescript-eslint/no-explicit-any */
import { generateFixedColorGradient } from '../../ui/colors';
import { IThemeContextUpdate } from '../../ui/contexts/ThemeProvider';
import { mixArrays } from '../../ui/utils';
import { IAgreement } from '../dashboard/types';

enum BookstoreType {
  BOOK,
  MAGAZINE,
  AUDIOBOOK,
  MULTIPLE,
}

export interface BookstoreLabels {
  singular: string;
  plural: string;
  prefixedSingular: string;
  prefixedPlural: string;
  prefix: string;
  prefixPlural: string;
}

function getBookstoreType(bookstoreTypes: string[]): BookstoreType {
  if (bookstoreTypes.length > 1) return BookstoreType.MULTIPLE;

  if (bookstoreTypes[0] === 'book') return BookstoreType.BOOK;

  if (bookstoreTypes[0] === "audiobook") return BookstoreType.AUDIOBOOK;

  return BookstoreType.MAGAZINE;
}

function getBookstoreLabels(bookstoreType: BookstoreType): BookstoreLabels {
  let labels: BookstoreLabels;

  if (bookstoreType === BookstoreType.BOOK) labels = { singular: 'Ebook', plural: 'Ebooks', prefix: 'o', prefixPlural: 'os', prefixedSingular: 'o Ebook', prefixedPlural: 'os Ebooks' };
  else if (bookstoreType === BookstoreType.MAGAZINE) labels = { singular: 'Revista', plural: 'Revistas', prefix: 'a', prefixPlural: 'as', prefixedSingular: 'a Revista', prefixedPlural: 'as Revistas' };
  else if (bookstoreType === BookstoreType.AUDIOBOOK) labels = { singular: 'Audiobook', plural: 'Audiobooks', prefix: 'o', prefixPlural: 'os', prefixedSingular: 'o Audiobook', prefixedPlural: 'os Audiobooks' };
  else labels = { singular: 'Obra', plural: 'Obras', prefix: 'a', prefixPlural: 'as', prefixedSingular: 'a Obra', prefixedPlural: 'as Obras' };

  labels.prefixPlural = labels.prefix + 's';
  labels.prefixedPlural = labels.prefixPlural + ' ' + labels.plural;
  labels.prefixedSingular = labels.prefix + ' ' + labels.singular;

  return labels;
}

export function parseAgreementToTheme(agreement: IAgreement): IThemeContextUpdate {
  const bookstoreType = getBookstoreType(agreement.bookstoreTypes);
  const bookstoreLabels = getBookstoreLabels(bookstoreType);
  const metadata = agreement.product != null ? (agreement.product as any).metadata : undefined;
  return {
    id: agreement.id,
    name: agreement.name,
    logo: metadata?.logoconvenio?.value || agreement.logo,
    slug: agreement.slug,
    exClientModule: agreement.exClientModule,
    product: agreement.product,
    colors: {
      primaryColor: agreement.primaryColor,
      secondaryColor: agreement.secondaryColor,
      menuColor: agreement.menuColor,
      menuFontColor: agreement.menuFontColor,
      primaryFontColor: agreement.primaryFontColor,
      secondaryFontColor: agreement.secondaryFontColor,
      graphColors: mixArrays(
        generateFixedColorGradient(agreement.primaryColor, 30),
        generateFixedColorGradient(agreement.secondaryColor, 20)
      ),
    },
    uraModuleCellphone: agreement.uraModuleCellphone,
    bookstoreTypes: agreement.bookstoreTypes,
    recurringBook: agreement.recurringBook,
    banners: agreement.banners,
    digitalMagazinesModule: agreement.digitalMagazinesModule,
    showBestSellers: agreement.showBestSellers,
    email: agreement.email,
    cellphone: agreement.cellphone,
    telephone: agreement.telephone,
    integratedLogin: agreement.integratedLogin,
    allowSignup: agreement.allowSignup,
    cpfModule: agreement.cpfModule,
    idp: agreement.idp,
    allowCpfLoginMethod: agreement.allowCpfLoginMethod,
    allowPromocodeLoginMethod: agreement.allowPromocodeLoginMethod,
    bookstoreLabels: bookstoreLabels,
    metadata: agreement.metadata,
  };
}

export function parseAgreementToThemeDash(agreement: IAgreement): IThemeContextUpdate {
  return {
    colors: {
      primaryColor: agreement.primaryColor,
      primaryFontColor: agreement.primaryFontColor,
      menuColor: agreement.menuColor,
      menuFontColor: agreement.menuFontColor,
      secondaryColor: agreement.secondaryColor,
      secondaryFontColor: agreement.secondaryFontColor,
      graphColors: mixArrays(
        generateFixedColorGradient(agreement.primaryColor, 30),
        generateFixedColorGradient(agreement.secondaryColor, 20)
      ),
    },
    extraData: { ...agreement },
    id: agreement.id,
    name: agreement.name,
    logo: agreement.logo,
    email: agreement.email,
    telephone: agreement.telephone,
    isLoading: false,
    banners: agreement.banners,
  };
}
